import InlineAlert from '../primitives/InlineAlert/InlineAlert';
import { Shield } from '@drift-labs/icons';

const VerifiedVaultsCallout = () => {
	return (
		<InlineAlert
			customIcon={Shield}
			variant="info"
			title="These managers have completed basic KYB checks and have provided further information regarding vault operation."
		/>
	);
};

export default VerifiedVaultsCallout;
